import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { getCurrentUser, getCurrentUserRole } from '../../_store/AccountStore/account.store';
import { ConfigService } from '../../_services/local/config.service';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../_store/mainStoreState';
import { DashboardService } from '../dashboard/dashboard.service';
import { MatIcon } from '@angular/material/icon';
import { hasSessionEdition } from 'src/app/_store/SessionStore/session.store';
import { SessionEdition } from 'src/app/_models/SessionEdition';

@Component({
  selector: 'app-dashboard-controls',
  templateUrl: './dashboard-controls.component.html',
  styleUrls: ['./dashboard-controls.component.scss'],
})
export class DashboardControlsComponent implements OnInit, OnDestroy {
  userRole$ = this.store.select(getCurrentUserRole);

  @ViewChild('mapWidget') private readonly mapWidget?: MatIcon;
  @ViewChild('mapEditWidget') private readonly mapEditWidget?: MatIcon;
  @ViewChild('esListWidget') private readonly esListWidget?: MatIcon;
  @ViewChild('spListWidget') private readonly spListWidget?: MatIcon;
  @ViewChild('pgmListWidget') private readonly pgmListWidget?: MatIcon;
  @ViewChild('equipmentListWidget')
  private readonly equipmentListWidget?: MatIcon;
  @ViewChild('alarmeListWidget') private readonly alarmeListWidget?: MatIcon;
  @ViewChild('avancementListWidget')
  private readonly avancementListWidget?: MatIcon;
  @ViewChild('logsListWidget') private readonly logsListWidget?: MatIcon;
  @ViewChild('historiqueWidget') private readonly historiqueWidget?: MatIcon;

  get element(): HTMLElement {
    return this.elRef.nativeElement;
  }

  logo!: string;
  existsSessionForCurrentUser$!: Observable<SessionEdition | undefined>;

  constructor(
    private elRef: ElementRef,
    private readonly configService: ConfigService,
    private readonly store: Store<MainStoreState>,
    private readonly dashboardService: DashboardService
  ) {}

  ngOnInit(): void {
    this.store.select(getCurrentUser).subscribe((user) => {
      this.existsSessionForCurrentUser$ = this.store.select(hasSessionEdition(user));
    });
  }

  ngOnDestroy(): void {
    this.dashboardService.removeDragSources();
  }

  initialize(): void {
    this.loadDragSources();
  }

  addComponent(componentType: string, event?: MouseEvent): void {
    this.dashboardService.addComponent(componentType, event && event.shiftKey);
  }

  private loadDragSources(): void {
    if (this.mapWidget) {
      this.dashboardService.addDragSource(this.mapWidget._elementRef.nativeElement, 'MapVecComponent');
    }

    if (this.mapEditWidget) {
      this.dashboardService.addDragSource(this.mapEditWidget._elementRef.nativeElement, 'MapEditComponent');
    }

    if (this.esListWidget) {
      this.dashboardService.addDragSource(this.esListWidget._elementRef.nativeElement, 'EsListComponent');
    }

    if (this.spListWidget) {
      this.dashboardService.addDragSource(this.spListWidget._elementRef.nativeElement, 'SpListComponent');
    }

    if (this.pgmListWidget) {
      this.dashboardService.addDragSource(this.pgmListWidget._elementRef.nativeElement, 'PgmListComponent');
    }

    if (this.equipmentListWidget) {
      this.dashboardService.addDragSource(this.equipmentListWidget._elementRef.nativeElement, 'EquipmentListComponent');
    }

    if (this.alarmeListWidget) {
      this.dashboardService.addDragSource(this.alarmeListWidget._elementRef.nativeElement, 'AlarmeListComponent');
    }

    if (this.avancementListWidget) {
      this.dashboardService.addDragSource(this.avancementListWidget._elementRef.nativeElement, 'AvancementListComponent');
    }

    if (this.logsListWidget) {
      this.dashboardService.addDragSource(this.logsListWidget._elementRef.nativeElement, 'LogListComponent');
    }

    if (this.historiqueWidget) {
      this.dashboardService.addDragSource(this.historiqueWidget._elementRef.nativeElement, 'HistoriqueComponent');
    }
  }

  changeLogo(event: 'dark' | 'light') {
    setTimeout(() => {
      this.logo = event === 'dark' ? 'assets/logo-dark.svg' : 'assets/logo.svg';
    });
  }
}
